import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { xeoLumPlus,  } from './data';
import { IXeoLumPlus } from './model';
import { ModalSchedulerGraphicComponent } from 'src/app/components/ui/modal-scheduler-graphic/modal-scheduler-graphic.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { AstCalendarService  } from 'src/app/services/sunTimes/suntimes.service';
import { SchedulerAncComponent } from 'src/app/components/scheduler-anc/scheduler-anc.component';



@Component({
    selector: 'app-xlum',
    // standalone: true,
    // imports: [],
    templateUrl: './xlum.component.html',
    styleUrl: './xlum.component.scss',
    standalone: false
})
export class XlumComponent implements OnInit {


  data: IXeoLumPlus = xeoLumPlus;
  outputKeys = Object.keys(xeoLumPlus.outputs);
  totalOut = this.data.outputs
  selectedOutput: number = 1;
  sunTimesData: any[] = [];

  hideSchedulerAnc: boolean = false;

  option = 1;
  selectedParams = this.getSelectedParamsByOption(this.option);
  @ViewChild(SchedulerAncComponent) schedulerAnc?: SchedulerAncComponent;


  constructor(private _modal: ModalService, private astCalendarService: AstCalendarService) { }


  ngOnInit(): void {

    this.sunTimesData = this.astCalendarService.getSunTimesForWeek(new Date(), this.data.location.lat, this.data.location.lon);

    this.totalOut = { ...this.data.outputs, totalSlaves: this.data.slaves?.length ?? 0 };

  }

  onOptionChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.option = Number(select.value);
    this.selectedParams = this.getSelectedParamsByOption(this.option);
  }

  onOutputChange(output: number): void {
    this.selectedOutput = output;
    console.log('Selected output:', output);
    // Aquí puedes actualizar los datos que se muestran según la salida seleccionada
  }

  // Obtener el objeto de programaciones para el scheduler-anc
  // Retorna un objeto con las programaciones de todas las salidas: {output1: [...], output2: [...], ...}
  getSchedulerData(): any {
    const totalMainOutputs = Object.keys(this.data.outputs).filter(key => key.startsWith('output')).length;
    const schedulerData: any = {};

    // Añadir programaciones de las salidas principales del dispositivo
    for (let i = 1; i <= totalMainOutputs; i++) {
      const outputKey = `output${i}`;
      schedulerData[outputKey] = this.data.scheduler?.[outputKey] || [];
    }

    // Añadir programaciones de los esclavos
    // Cada esclavo añade una salida adicional (output5, output6, etc.)
    if (this.data.slaves && this.data.slaves.length > 0) {
      this.data.slaves.forEach((slave, index) => {
        const outputKey = `output${totalMainOutputs + index + 1}`;
        schedulerData[outputKey] = slave.scheduler?.output1 || [];
      });
    }

    return schedulerData;
  }

  // Obtener el número total de salidas (dispositivo principal + esclavos)
  getTotalOutputs(): number {
    const mainOutputs = Object.keys(this.data.outputs).filter(key => key.startsWith('output')).length;
    const slaveOutputs = this.data.slaves?.length || 0;
    return mainOutputs + slaveOutputs;
  }

  // Función para formatear la última conexión
  formatLastSeen(lastseen: string): string {
    if (!lastseen) return 'Nunca';
    const date = new Date(lastseen);
    return date.toLocaleString('es-ES');
  }

  getSelectedParamsByOption(option: number) {
    if (option === 1) {
      return this.data.externalAnalyzers?.[0]?.electricalParams
    }

    if (option === 2) {
      return this.data.externalAnalyzers?.[1]?.electricalParams
    }

    // Si option > 2, es un esclavo (opción 3 = esclavo 0, opción 4 = esclavo 1, etc.)
    const slaveIndex = option - 3;
    if (slaveIndex >= 0 && this.data.slaves && this.data.slaves[slaveIndex]) {
      // Convertir datos monofásicos del esclavo a formato compatible
      const slave = this.data.slaves[slaveIndex];
      return {
        perPhase: [{
          voltage_V: slave.electrical.voltage_V,
          current_A: slave.electrical.current_A,
          activePower_W: slave.electrical.activePower_W
        }],
        totals: {
          avgVoltage_V: slave.electrical.voltage_V,
          avgCurrent_A: slave.electrical.current_A,
          totalActivePower_W: slave.electrical.activePower_W,
          totalEnergy_kWh: slave.electrical.energy_kWh * 1000,
          partialEnergy_kWh: slave.counters?.partial || 0,
          frequency_Hz: slave.electrical.frequency_Hz || 50
        }
      };
    }

    return null;
  }

  isSlaveSelected(): boolean {
    return this.option > 2;
  }

  getOptionLabel(): string {
    if (this.option === 1) return 'Analizador 1';
    if (this.option === 2) return 'Analizador 2';
    const slaveIndex = this.option - 3;
    if (slaveIndex >= 0 && this.data.slaves && this.data.slaves[slaveIndex]) {
      const slave = this.data.slaves[slaveIndex];
      // Usar model como identificador principal
      return slave.model || slave.name || slave.notes || `Esclavo ${slave.address}`;
    }
    return 'N/A';
  }

  getMaxOption(): number {
    // 2 analizadores + número de esclavos
    return 2 + (this.data.slaves?.length || 0);
  }

  previousOption(): void {
    if (this.option > 1) {
      this.option--;
      this.selectedParams = this.getSelectedParamsByOption(this.option);
    }
  }

  nextOption(): void {
    if (this.option < this.getMaxOption()) {
      this.option++;
      this.selectedParams = this.getSelectedParamsByOption(this.option);
    }
  }

  toggleOutput(key: string): void {
    if (this.data.outputs.hasOwnProperty(key)) {
      this.data.outputs[key] = !this.data.outputs[key];
    }
  }

  toggleOutputSlave(index: number): void {
    if (this.data.slaves[index] && typeof this.data.slaves[index].outState === 'boolean') {
      this.data.slaves[index].outState = !this.data.slaves[index].outState;
    }
  }


  getCurrentTotal(): number {
    if (!this.selectedParams) {
      return 0;
    }

    const average = this.selectedParams.totals?.avgCurrent_A;
    if (typeof average === 'number') {
      return average * 3;
    }

    const perPhase = this.selectedParams.perPhase ?? [];
    return perPhase.reduce((sum: number, phase: any) => sum + (phase?.current_A ?? 0), 0);
  }

  getVoltageTotal(): number {
    if (!this.selectedParams) {
      return 0;
    }

    const average = this.selectedParams.totals?.avgVoltage_V;
    if (typeof average === 'number') {
      return average;
    }

    const perPhase = this.selectedParams.perPhase ?? [];
    if (!perPhase.length) {
      return 0;
    }

    const sum = perPhase.reduce((acc: number, phase: any) => acc + (phase?.voltage_V ?? 0), 0);
    return sum / perPhase.length;
  }

  getPowerTotal(): number {
    if (!this.selectedParams) {
      return 0;
    }

    const total = this.selectedParams.totals?.totalActivePower_W;
    if (typeof total === 'number') {
      return total;
    }

    const perPhase = this.selectedParams.perPhase ?? [];
    return perPhase.reduce((sum: number, phase: any) => sum + (phase?.activePower_W ?? 0), 0);
  }

  getEnergyTotal(): number {
    if (!this.selectedParams) {
      return 0;
    }

    const total = this.selectedParams.totals?.totalEnergy_kWh;
    if (typeof total === 'number') {
      return total;
    }

    const perPhase = this.selectedParams.perPhase ?? [];
    return perPhase.reduce((sum: number, phase: any) => sum + (phase?.energy_kWh ?? 0), 0);
  }

  getFrequencyTotal(): number {
    if (!this.selectedParams) {
      return 0;
    }

    const total = this.selectedParams.totals?.frequency_Hz;
    if (typeof total === 'number') {
      return total;
    }

    const perPhase = this.selectedParams.perPhase ?? [];
    if (!perPhase.length) {
      return 0;
    }

    const sum = perPhase.reduce((acc: number, phase: any) => acc + (phase?.frequency_Hz ?? 0), 0);
    return sum / perPhase.length;
  }

  // Función para abrir el modal de programación
  openSchedulerModal(): void {
    // Hide the background scheduler component to avoid canvas/icon overlap
    this.hideSchedulerAnc = true;

    // If we have a reference to the scheduler component, ask it to pause rendering
    try {
      this.schedulerAnc?.pauseRendering();
    } catch (e) {
      console.warn('Failed to pause schedulerAnc rendering', e);
    }

    const modalRef = this._modal.open(ModalSchedulerGraphicComponent, {
      centered: true,
      scrollable: true,
      windowClass: 'scheduler-window' // clase que usarás en el CSS
    });

    modalRef.componentInstance.schedulerData = this.getSchedulerData();
    modalRef.componentInstance.selectedOutput = this.selectedOutput;
    modalRef.componentInstance.deviceData = this.data;
    // Pass sunTimesData (calculated array with real astronomical data)
    modalRef.componentInstance.sunTimes = this.sunTimesData;

    // When modal closes, resume scheduler rendering
    modalRef.result.then(() => {
      try { this.schedulerAnc?.resumeRendering(); } catch (e) { console.warn(e); }
      // Restore scheduler visibility
      this.hideSchedulerAnc = false;
    }).catch(() => {
      try { this.schedulerAnc?.resumeRendering(); } catch (e) { console.warn(e); }
      // Restore scheduler visibility on dismiss as well
      this.hideSchedulerAnc = false;
    });
  }


}
